<template>
  <div id="main" :class="selectedTheme" class="h-full bg-primary content font-default" @click="TrackDOMClick">
    <main-header></main-header>
    <home />
    <div class="p-2 px-3 md:px-10">
      <router-view />
    </div>
    <main-footer />
    <mobile-menu class="menuPosition" v-if="hamburgerVisible" />
  </div>
</template>

<script>
import Home from './views/Home'
import mainFooter from './components/Footer'
import { mapGetters, mapActions } from 'vuex'
import MobileMenu from './components/BottomNavMenu'
import MainHeader from './components/Header'
import '../public/sw-config'

export default {
  name: 'App',
  computed: {
    ...mapGetters(['hamburgerClick', 'hamburgerVisible', 'selectedTheme'])
  },
  methods: {
    ...mapActions(['TrackDOMClick', 'setTheme'])
  },
  created () {
    this.setTheme()
  },
  components: {
    Home,
    MobileMenu,
    MainHeader,
    mainFooter
  }
}
const vh = window.innerHeight * 0.01 /* Get height of current viewport & convert to 100 as base reference */
document.documentElement.style.setProperty('--vh', `${vh}px`) // Add --vh to the root DOM element
window.addEventListener('resize', () => { // Listen to change in viewport size & recalculate vertical height
  const vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})
window.addEventListener('scroll', () => {
  let pageTopOffset = 0
  if (window.pageYOffset > window.innerHeight || window.scrollY > window.innerHeight) { /* Add offset for bottom spacing */
    pageTopOffset = window.pageYOffset - 5
  } else {
    pageTopOffset = window.pageYOffset // Return the value currently scrolled along the Y axis
    document.getElementById('main').click()
  }
  const vh = (pageTopOffset + window.innerHeight) * 0.01 // Use the value currently scrolled along the Y axis in calculating new position
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})
// service worker registration
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('sw-config.js')
    .then(function () {})
    .catch(function () {
    })
}
</script>
<style>
.menuPosition{
  top: calc(var(--vh, 1vh) * 100);
}
</style>
